module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.0cf2bd40.webp";